<template>
    <div style="padding-top: 80px">
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="!showEncuesta">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Buscar Encuestas Contestadas</p>

            </v-card-title>
            <v-form ref="form">
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Reporte</span>
                                <v-text-field v-model="datosE.nrreporte" outlined dense :rules="rulesInputs"
                                    maxlength="12" @keypress="ruleNumber($event, datosE.nrreporte)"
                                    @keydown.enter.prevent="buscar()"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Índice</span>
                                <v-text-field v-model="datosE.svindice" outlined dense :rules="rulesInputs"
                                    maxlength="3" @keypress="ruleNumber($event, datosE.svindice)"
                                    @keydown.enter.prevent="buscar()"></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                    <v-col md="12">
                        <v-row justify="center">

                            <v-btn class="ma-2" color="primary" title="Buscar" @click="buscar()">
                                <span style='color: white;'>Buscar</span>
                            </v-btn>
                        </v-row>
                    </v-col>

                </v-card-text>


            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showFiltro && !showEncuesta">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Encuestas Contestadas</p>
            </v-card-title>
            <v-card-text>
                <DataTable :url="urlListado" :columns="columns" :params="displayInputs"
                    :formatterActions="formatterActions" :order="[]" @apiDT="apiDT = $event"></DataTable>

            </v-card-text>
        </v-card>



        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showEncuesta">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Buscar Encuestas Contestadas</p>

            </v-card-title>
            <v-card-text v-if="!loadingModal">
                <div class="spinner-container text-center">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
                <br />
            </v-card-text>
            <v-form ref="form3" v-if="loadingModal" v-model="valid" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card-text style="background-color:#10ac84">
                                <v-row align="center" justify="end">
                                    <v-col cols="1">
                                        <v-btn title="Regresar Encuesta" color="red" @click="cancelarEncuesta()"
                                            style="height: 30px; min-width: 5px; width: 70%;">
                                            <v-icon color="white">mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <h3 class="text-center" style="color: white">Encuesta {{ datos.tipoencuesta.egdesc }} con
                                    reporte {{ datos.nrreporte }}-{{ datos.svindice }}</h3>

                            </v-card-text>
                            <v-card-text>
                                <div v-for="(item, index) in formulariopreguntas" :key="index">
                                    <center v-if="index > 0">
                                        <br />
                                        <br />
                                    </center>
                                    <center>
                                        <v-card style="border: 5px solid #E0E0E0">

                                            <center>
                                                <br />
                                                <span style="font-size:19px;">{{ item.evorden === 3 && preguntaRadio ? preguntaRadio : item.evpregunta }}</span>

                                                <v-col cols="10" justify="center">
                                                    <v-row justify="center" align-content="center"
                                                        v-if="item.trdesc == 'Univaluada'">
                                                        <v-radio-group v-model="valueradio[index].rpid"
                                                            :class="classdisabled" required
                                                            color="black" row>

                                                            <v-radio :value="item1.rpid" :label="item1.rpdesc"
                                                                v-for="(item1, index1) in formularioRespuestas[index]"
                                                                :key="index1"></v-radio>


                                                        </v-radio-group>
                                                    </v-row>
                                                    <div
                                                        v-if="item.trdesc == 'Univaluada-Condicion' || item.trdesc == 'Univaluada-Porque'">
                                                        <v-row justify="center" align-content="center">
                                                            <v-radio-group v-model="valueradio[index].rpid"
                                                                 :class="classdisabled" required
                                                                row>

                                                                <v-radio :value="item1.rpid" :label="item1.rpdesc"
                                                                    v-for="(item1, index1) in formularioRespuestas[index]"
                                                                    :key="index1"></v-radio>


                                                            </v-radio-group>
                                                        </v-row>
                                                        <v-row justify="center" align-content="center"
                                                            v-if="valueradio[index].rpid != null && valueradio[index].rpid != ''">
                                                            <v-col md="8">
                                                                <span style="font-size:24px">Sugerencia:</span>
                                                                <br />
                                                                <v-textarea :counter="500"
                                                                    :maxlength="$store.state.maxLengthComentarios"
                                                                    outlined 
                                                                     :readonly="classdisabled === 'disable-action'"
                                                                    v-model="valueradio[index].evasugerencia"
                                                                    v-on:blur="valueradio[index].evasugerencia = valueradio[index].evasugerencia != null ? valueradio[index].evasugerencia.trim() : null"></v-textarea>

                                                            </v-col>


                                                        </v-row>



                                                    </div>

                                                    <v-row justify="center" align-content="center"
                                                        v-if="item.trdesc == 'Abierta'">

                                                        <v-col md="8">
                                                            <v-textarea :counter="500"
                                                                :maxlength="$store.state.maxLengthComentarios" outlined
                                                                 :readonly="classdisabled === 'disable-action'"
                                                                v-model="valueradio[index].evaporque"
                                                                v-on:blur="valueradio[index].evaporque = valueradio[index].evaporque != null ? valueradio[index].evaporque.trim() : null"
                                                                required name="input-7-4"></v-textarea>

                                                        </v-col>

                                                    </v-row>
                                                    <br />
                                                </v-col>



                                            </center>




                                        </v-card>


                                    </center>




                                </div>


                            </v-card-text>

                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="showMotivo">
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Seleccione el Motivo de No Conformidad</span>
                                <v-select outlined dense :items="motivoArray" v-model="motivo"
                                    no-data-text="Seleccione motivo" :class="classdisabled2" item-text="cnconcepto"
                                    item-value="cnid" placeholder="Seleccione una opción" :rules="ruleSelect3">

                                </v-select>
                            </div>

                        </v-col>
                    </v-row>
                    <v-col md="12" v-if="showMotivo && classdisabled2 == ''">
                        <v-row justify="center">

                            <v-btn class="ma-2" color="primary" title="Guardar" @click="guardarClasificacion()"
                                :disabled="disabledSaveGuardar">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <br />
                        </v-row>
                    </v-col>

                </v-card-text>


            </v-form>
        </v-card>





    </div>
</template>



<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Calidad from "@/services/Calidad/Calidad.service.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable
    },
    data() {
        return {
            showFiltro: false,
            showEncuesta: false,

            disabledSaveGuardar: false,
            urlListado: "Calidad/ListadoEncuestasContestadas",
            columns: [
                { name: 'nrreporte', data: 'nrreporte', title: "Reporte" },
                { name: 'svindice', data: 'svindice', title: "Índice" },
                { name: 'egdesc', data: 'egdesc', title: "Encuesta" },
                { name: 'eefechaeval', data: 'eefechaeval', title: "Fecha Respuesta" },
                { name: "detalle", data: "detalle", title: "", formatter: [this, "formatearDetalle"], orderable: false },

            ],
            datosE: {
                nrreporte: '',
                svindice: '1'
            },
            datos: {
                tipoencuesta: '',
                nrreporte: '',
                svindice: ''
            },

            motivoArray: [],
            motivo: '',
            showMotivo: false,

            ruleSelect3: [(v) => !!v || "Campo requerido"],
            formulariopreguntas: [],
            formularioRespuestas: [],
            formulariopreguntastemp: [],
            rulesInputs: [(v) => !!v || "Campo requerido"],
            conteo: 0,
            displayInputs: {
                nrreporte: 0,
                svindice: 0
            },
            valueradio: [],
            formatterActions: [
                { click: [this, "irDetalle"] },

            ],
            loadingModal: false,
            valid: true,
            classdisabled: "disable-action",
            classdisabled2: "",

        }

    },
    watch: {
        async 'formulariopreguntastemp'(val) {
            if (val.length > 0) {
                let v = this;
                val.forEach(async function (key, value) {

                    const porque = key.evaporque == null || key.evaporque == '' ? key.evasugerencia : key.evaporque;
                    const sugerencia = key.evasugerencia == null || key.evasugerencia == '' ? key.evaporque : key.evasugerencia;

                    v.valueradio.push({ 'evid': key.evid, 'rpid': key.rpid, 'evaporque': porque, 'evasugerencia': sugerencia });
                    let calificacion = parseInt(key.rpdesc);

                    if (key.evorden == 2 && v.datos.tipoencuesta.egid == 12) {// de la segunda pregunta, que sea detractor y sea encuasta de conclusión
                        if (calificacion <= 6 ) {
                            v.showMotivo = true;
                            v.motivo = key.evamotivo;
                            if (key.evamotivo == null || key.evamotivo == '') {
                                v.classdisabled2 = "";
                            }
                            else {
                                v.classdisabled2 = "disable-action";
                            }

                        } else {
                            v.showMotivo = false;
                            v.motivo = '';
                        }
                    }
                    if (key.evorden == 1 && v.datos.tipoencuesta.egid == 14) {// de la primera pregunta, que sea detractor y sea encuasta de termino
                        let calificacionT = parseInt(key.rpid);
                        if (calificacionT <= 6 ) {
                            v.showMotivo = true;
                            v.motivo = key.evamotivo;
                            if (key.evamotivo == null || key.evamotivo == '') {
                                v.classdisabled2 = "";
                            }
                            else {
                                v.classdisabled2 = "disable-action";
                            }

                        } else {
                            v.showMotivo = false;
                            v.motivo = '';
                        }
                    }
                });
            }
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
    },
    methods: {
        async guardarClasificacion() {
            this.disabledSaveGuardar = true;
            this.$refs.form3.validate();
            if (this.$refs.form3.validate()) {

                await Calidad.guardarClasificacion(this).then(response => {
                    if (response) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se clasificó correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.classdisabled2 = "disable-action";
                        });

                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'No se clasificó correctamente, favor de avisar a desarrollo@ausa.com.mx',
                            showConfirmButton: true,
                            allowOutsideClick: false
                        }).then(async () => {
                            this.cancelarEncuesta();

                        });
                    }

                });

            }
            else {
                this.disabledSaveGuardar = false;
            }


        },
        formatearDetalle(x) {
            return `<button style="width: 38px;height: 35px;" type="button" data-action="0" data-params="${x}" class="dt-formatterAction ma-1 ma-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small green" title="Ver Encuesta"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-eye theme--light white--text"></i></span></button>`;

        },
        async irDetalle(params, item, fila) {

            this.showEncuesta = true;
            this.datos.tipoencuesta = { 'egid': item.egid, 'egdesc': item.egdesc };
            this.datos.nrreporte = item.nrreporte;
            this.datos.svindice = item.svindice;
            let responseMotivo = await Calidad.ObtenerListadoMotivo(this);
            this.motivoArray = responseMotivo;

            await this.verEncuestaGral();
        },
        async verEncuestaGral() {

            let response2 = await Calidad.ObtenerPreguntasEncuestaDetalle(this);
            this.formulariopreguntastemp = response2;
            this.formulariopreguntas = response2;

            let response3 = await Calidad.ObtenerRespuestasEncuestaDetalle(this);

            this.formularioRespuestas = response3;


            this.loadingModal = true;

        },
        cancelarEncuesta() {
            this.showFiltro = false;
            this.showEncuesta = false;
            this.disabledSaveGuardar = false;
            this.datosE.nrreporte = '';
            this.datosE.svindice = '1';

            this.datos.tipoencuesta = '';
            this.datos.nrreporte = '';
            this.datos.svindice = '';
            this.motivo = '';
            this.showMotivo = false;
            this.classdisabled2 = "";
            this.formulariopreguntas = [];
            this.formularioRespuestas = [];
            this.formulariopreguntastemp = [];
            this.conteo = 0;
            this.displayInputs.nrreporte = 0;
            this.displayInputs.svindice = 0;

            this.valueradio = [];
            this.loadingModal = false;
            this.valid = true;
        },
        async buscar() {

            this.$refs.form.validate();

            if (this.$refs.form.validate() && this.conteo == 0) {
                this.conteo = 1;

                let response = await Calidad.BuscarContestadas(this);

                if (response.length > 1) {

                    const reporte = this.datosE.nrreporte;
                    const indice = this.datosE.svindice;

                    this.displayInputs.nrreporte = reporte;
                    this.displayInputs.svindice = indice;

                    this.showFiltro = true;
                }
                else if (response.length == 1) {
                    this.showEncuesta = true;
                    this.datos.tipoencuesta = { 'egid': response[0].egid, 'egdesc': response[0].egdesc };

                    this.datos.nrreporte = response[0].nrreporte;
                    this.datos.svindice = response[0].svindice;
                    let responseMotivo = await Calidad.ObtenerListadoMotivo(this);
                    this.motivoArray = responseMotivo;


                    await this.verEncuestaGral();
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'No se encontró ninguna encuesta contestada del reporte e índice buscado',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        timer: 5000,
                    }).then(async () => {
                        this.cancelarEncuesta();

                    });
                }




                this.conteo = 0;

            }

        },
        ruleNumber: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57)) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
    },
    async mounted() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "12"//modulo de calidad
        ).then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });

    }


}
</script>